import { useMemo } from "react";

/* ═══════════════════════════════════════════════════════════════
   Avatar reutilizable
   - Si hay `src` (avatar URL), muestra la foto
   - Si no, muestra iniciales sobre color derivado del nombre (estilo Airbnb/GitHub)
   ═══════════════════════════════════════════════════════════════ */

const PALETTE = [
  { bg: "linear-gradient(135deg,#06b6d4,#059669)", fg: "#fff" },   // cyan-emerald
  { bg: "linear-gradient(135deg,#8b5cf6,#ec4899)", fg: "#fff" },   // violet-pink
  { bg: "linear-gradient(135deg,#f59e0b,#ef4444)", fg: "#fff" },   // amber-red
  { bg: "linear-gradient(135deg,#3b82f6,#06b6d4)", fg: "#fff" },   // blue-cyan
  { bg: "linear-gradient(135deg,#10b981,#14b8a6)", fg: "#fff" },   // emerald-teal
  { bg: "linear-gradient(135deg,#f97316,#f59e0b)", fg: "#fff" },   // orange-amber
];

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function initials(name) {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function paletteFor(name) {
  const str = String(name || "");
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export default function Avatar({ name, src, size = 56, className = "", testid }) {
  const style = useMemo(() => {
    if (src) return {};
    const p = paletteFor(name);
    return { background: p.bg, color: p.fg };
  }, [src, name]);

  const fontSize = Math.max(11, Math.round(size * 0.38));
  const dim = { width: size, height: size };
  const fullSrc = src && src.startsWith("/api/")
    ? `${REACT_APP_BACKEND_URL}${src}`
    : src;

  if (fullSrc) {
    return (
      <img
        src={fullSrc}
        alt={name || "avatar"}
        className={`rounded-full object-cover border border-white/15 ${className}`}
        style={dim}
        data-testid={testid || "avatar-image"}
        loading="lazy"
      />
    );
  }
  return (
    <div
      className={`rounded-full flex items-center justify-center font-semibold select-none border border-white/15 shrink-0 ${className}`}
      style={{ ...style, ...dim, fontSize }}
      data-testid={testid || "avatar-initials"}
      aria-label={`Avatar de ${name || "usuario"}`}
    >
      {initials(name)}
    </div>
  );
}
